import { useIntl } from "react-intl";

import { useAnalyticsEvents } from "@atlaskit/analytics-next";
import EditIcon from "@atlaskit/icon/core/edit";
import EpicIcon from "@atlaskit/icon/core/epic";
import FlagIcon from "@atlaskit/icon/core/flag";
import PremiumIcon from "@atlaskit/icon/core/premium";

import { useUserContext } from "@/components/user-context/user-context-provider";
import { Link } from "@/libraries/design/components";

import { tabbedHeroSectionIntakeRequestMessages } from "../reusable-xflow-hero-component/tabbed-hero-section.messages.tsx";

import { ContentTypeImage } from "./content-type-image.tsx";

import type { TabProps, TabType } from "./tab-type.tsx";

type RequestContentTypeProps = TabProps;

export const RequestContentType: TabType = ({}: RequestContentTypeProps) => {
    const intl = useIntl();
    const { createAnalyticsEvent } = useAnalyticsEvents();
    const { user } = useUserContext();

    return (
        <ContentTypeImage
            imageSrc="https://dam-cdn.atl.orangelogic.com/AssetLink/0386o60lcs23u0wxo60c181728fvqa65.webp"
            imageAlt="A list of 4 service requests with fields for summary, status, requestor, channel and response. There is a search bar above the list of requests."
            title={intl.formatMessage(
                tabbedHeroSectionIntakeRequestMessages.contentTitle
            )}
            description={intl.formatMessage(
                tabbedHeroSectionIntakeRequestMessages.contentDescription
            )}
            hideSeparator={true}
            iconCollection={[
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionIntakeRequestMessages.contentFeaturePoint1
                    ),
                    icon: <PremiumIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionIntakeRequestMessages.contentFeaturePoint2
                    ),
                    icon: <EditIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionIntakeRequestMessages.contentFeaturePoint3
                    ),
                    icon: <EpicIcon label="" />
                },
                {
                    description: intl.formatMessage(
                        tabbedHeroSectionIntakeRequestMessages.contentFeaturePoint4
                    ),
                    icon: <FlagIcon label="" />
                }
            ]}
            cta={
                // eslint-disable-next-line @atlassian/a11y/anchor-has-content, @atlassian/a11y/link-name
                <Link
                    href={"/software/jira/service-management"}
                    text={intl.formatMessage(
                        tabbedHeroSectionIntakeRequestMessages.contentCta
                    )}
                    type={"primary"}
                    dataEventProps={{
                        "data-product-key": "jiraServiceManagement",
                        "data-event-component": "linkButton",
                        "data-event-container": "tabsMenu",
                        "data-event": "clicked",
                        "data-label": "try-it-out",
                        "data-label-english": "Explore Jira Service Management",
                        "data-track-event":
                            "jsm-pt.content-types.intake-request.cta"
                    }}
                    onClick={() => {
                        createAnalyticsEvent({
                            eventName: "jsm-crossflow-tab-cta-clicked",
                            eventType: "ui",
                            action: "clicked",
                            actionSubject: "linkButton",
                            actionSubjectId: "jsmCrossFlowHeroSection",
                            attributes: {
                                reactComponent: "RequestContentType",
                                tab: "intake-request",
                                userTeamType:
                                    user["extended_profile"]?.team_type
                            }
                        }).fire();
                    }}
                />
            }
            reverseLayout
        />
    );
};
